import { Directive, Input, HostListener } from '@angular/core';
import { ClickTrackerService } from 'src/app/services/click-tracker/click-tracker.service';
import { ClickEventNumbersEnum } from 'src/app/interfaces/clickEventNumbers';

@Directive({
  selector: '[trackClickEvent]'
})
export class TrackClickDirective {

  @Input() eventNumber!: ClickEventNumbersEnum;
  @Input() eventDetails?: string = '';

  constructor(private clickTrackerService: ClickTrackerService) {}

  @HostListener('click') onClick() {
    const details = this.eventDetails || ''; 
    this.clickTrackerService.handleButtonClick(this.eventNumber, details);
  }
}
